export default __webpack_public_path__ + "static/media/loader-1.8344bc8e.svg";